import { loadSelectItems } from "#/admin/legacy/sp-select/load-select-items.js";
import "#legacy/admin/page_builder/modals/base.js";

window.Sparkle ??= {};
window.Sparkle.PageBuilder ??= {};
window.Sparkle.PageBuilder.Modal ??= {};

Sparkle.PageBuilder.Modal.AssessmentPicker = class AssessmentPicker extends Sparkle.PageBuilder.Modal.Base {
  constructor(options) {
    super(options);
    this.getOutput = this.getOutput.bind(this);
    if (options == null) {
      options = {};
    }
    this.select = this.page.element.querySelector('[name="assessment_id"]');
    this.savedValue = options.selectedValue ?? "";
    this.choicesReady = this.waitForChoices(
      loadSelectItems(this.select, "/admin/assessments.json?api=quantum", {
        selected: options.selectedValue,
      }),
    ).then((payload) => {
      this.choicesLoaded = Boolean(payload);

      return payload;
    });
  }

  // Without its choices the picker is empty, so the saved assessment stays.
  getOutput() {
    return this.choicesLoaded ? this.select.value : this.savedValue;
  }
};
Sparkle.PageBuilder.Modal.AssessmentPicker.prototype.template = "assessment-picker-modal";
Sparkle.PageBuilder.Modal.AssessmentPicker.prototype.title = "Choose an Assessment";
